import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { NgMarqueeModule } from 'ng-marquee';
import { AppComponent } from './app.component';
import { DatePipe, CommonModule } from '@angular/common';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ReasonsToInvestComponent } from './about-us/9-reasons-to-invest/9-reasons-to-invest.component';
import { CareersAndTrainingComponent } from './about-us/careers-and-training/careers-and-training.component';
import { CoegaDevelopmentFoundationComponent } from './about-us/coega-development-foundation/coega-development-foundation.component';
import { ImportantLinksComponent } from './about-us/important-links/important-links.component';
import { LocationsComponent } from './about-us/locations/locations.component';
import { ShareholderInformationComponent } from './about-us/shareholder-information/shareholder-information.component';
import { SmmeComponent } from './about-us/smme/smme.component';
import { CoegaDevelopmentCorporationComponent } from './about-us/coega-development-corporation/coega-development-corporation.component';
import { WhoWeAreComponent } from './about-us/who-we-are/who-we-are.component';
import { CarouselComponent } from './carousel/carousel.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PageContentComponent } from './page-content/page-content.component';
import { SezInvestmentsComponent } from './sez-investments/sez-investments.component';
import { IncentivesComponent } from './sez-investments/incentives/incentives.component';
import { InvestmentSectorsComponent } from './sez-investments/investment-sectors/investment-sectors.component';
import { SezOperationsComponent } from './sez-investments/sez-operations/sez-operations.component';
import { NmblpComponent } from './sez-investments/nmblp/nmblp.component';
import { OneStopInvestorsServiceCentreComponent } from './sez-investments/one-stop-investors-service-centre/one-stop-investors-service-centre.component';
import { CommercialServicesComponent } from './commercial-services/commercial-services.component';
import { CoegaHumanCapitalSolutionsComponent } from './commercial-services/coega-human-capital-solutions/coega-human-capital-solutions.component';
import { CoegaVulindelaAccommodationAndConferenceCentreComponent } from './commercial-services/coega-vulindela-accommodation-and-conference-centre/coega-vulindela-accommodation-and-conference-centre.component';
import { CoegaCorporateTravelComponent } from './commercial-services/coega-corporate-travel/coega-corporate-travel.component';
import { BluewaterBaySunriseHotelComponent } from './commercial-services/bluewater-bay-sunrise-hotel/bluewater-bay-sunrise-hotel.component';
import { EventManagementServicesComponent } from './commercial-services/event-management-services/event-management-services.component';
import { CoegaTelecomsComponent } from './commercial-services/coega-telecoms/coega-telecoms.component';
import { CruxMaritimeSolutionsComponent } from './commercial-services/crux-maritime-solutions/crux-maritime-solutions.component';
import { ProjectManagementServicesComponent } from './project-management-services/project-management-services.component';
import { ProjectsMapComponent } from './project-management-services/projects-map/projects-map.component';
import { OurProgrammesComponent } from './project-management-services/our-programmes/our-programmes.component';
import { OurClientsComponent } from './project-management-services/our-clients/our-clients.component';
import { OurInvestorsComponent } from './our-investors/our-investors.component';
import { TendersComponent } from './tenders/tenders.component';
import { CurrentTendersComponent } from './tenders/current-tenders/current-tenders.component';
import { TenderResultsComponent } from './tenders/tender-results/tender-results.component';
import { AwardedTendersComponent } from './tenders/awarded-tenders/awarded-tenders.component';
import { ArchivedTendersComponent } from './tenders/archived-tenders/archived-tenders.component';
import { ProcessPaymentComponent } from './tenders/process-payment/process-payment.component';
import { GalleryComponent } from './gallery/gallery.component';
import { GalleryLandingComponent } from './gallery/landing/landing.component';
import { DocumentLibraryComponent } from './document-library/document-library.component';
import { MediaComponent } from './media/media.component';
import { MediaEnquiriesComponent } from './media/media-enquiries/media-enquiries.component';
import { MediaReleasesComponent } from './media/media-releases/media-releases.component';
import { VideosComponent } from './media/videos/videos.component';
import { NewslettersComponent } from './media/newsletters/newsletters.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { TermsComponent } from './terms/terms.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { PopiComponent } from './popi/popi.component';
import { CareersComponent } from './careers/careers.component';
import { AlumniComponent } from './alumni/alumni.component';
import { SiteMapComponent } from './site-map/site-map.component';
import { AppConfig } from './config/app-config';
import { InfrastructureDevelopmentAndFacilitiesManagementComponent } from './project-management-services/our-programmes/infrastructure-development-and-facilities-management/infrastructure-development-and-facilities-management.component';
import { SouthAfricanMarineFuelsComponent } from './project-management-services/our-programmes/south-african-marine-fuels/south-african-marine-fuels.component';
import { SmallBusinessFinanceSolutionComponent } from './project-management-services/our-programmes/small-business-finance-solution/small-business-finance-solution.component';
import { WildCoastSezComponent } from './project-management-services/our-programmes/wild-coast-sez/wild-coast-sez.component';
import { CoegaAfricaProgrammeComponent } from './project-management-services/our-programmes/coega-africa-programme/coega-africa-programme.component';
import { DepartmentOfEducationComponent } from './project-management-services/our-programmes/department-of-education/department-of-education.component';
import { DepartmentOfHealthComponent } from './project-management-services/our-programmes/department-of-health/department-of-health.component';
import { DepartmentOfSocialDevelopmentComponent } from './project-management-services/our-programmes/department-of-social-development/department-of-social-development.component';
import { DepartmentOfTourismComponent } from './project-management-services/our-programmes/department-of-tourism/department-of-tourism.component';
import { PublicWorksComponent } from './project-management-services/our-programmes/public-works/public-works.component';
import { MediaArticleComponent } from './media/media-releases/media-article/media-article.component';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { TenderDownloadComponent } from './tenders/tender-download/tender-download.component';
import { CurrentVacanciesComponent } from './careers/current-vacancies/current-vacancies.component';
import { ApplyComponent } from './careers/current-vacancies/apply/apply.component';
import { SiteSearchComponent } from './site-search/site-search.component';
import { ToastComponent } from './toast/toast.component';
import { BsaComponent } from './bsa/bsa.component';
import { BsaEnquiryComponent } from './bsa/bsa-enquiry/bsa-enquiry.component';
import { CacheInterceptor } from './cache-Interceptor.service';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
//import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
  onSameUrlNavigation: 'reload',
  //enableTracing: true
};

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    FooterComponent,
    AboutUsComponent,
    ReasonsToInvestComponent,
    CareersAndTrainingComponent,
    CoegaDevelopmentFoundationComponent,
    ImportantLinksComponent,
    LocationsComponent,
    ShareholderInformationComponent,
    SmmeComponent,
    WhoWeAreComponent,
    CoegaDevelopmentCorporationComponent,
    CarouselComponent,
    BreadcrumbComponent,
    PageContentComponent,
    SezInvestmentsComponent,
    IncentivesComponent,
    InvestmentSectorsComponent,
    SezOperationsComponent,
    NmblpComponent,
    OneStopInvestorsServiceCentreComponent,
    CommercialServicesComponent,
    CoegaHumanCapitalSolutionsComponent,
    CoegaVulindelaAccommodationAndConferenceCentreComponent,
    CoegaCorporateTravelComponent,
    BluewaterBaySunriseHotelComponent,
    EventManagementServicesComponent,
    CoegaTelecomsComponent,
    CruxMaritimeSolutionsComponent,
    ProjectManagementServicesComponent,
    ProjectsMapComponent,
    OurProgrammesComponent,
    OurClientsComponent,
    OurInvestorsComponent,
    TendersComponent,
    CurrentTendersComponent,
    TenderResultsComponent,
    AwardedTendersComponent,
    ArchivedTendersComponent,
    ProcessPaymentComponent,
    GalleryComponent,
    GalleryLandingComponent,
    DocumentLibraryComponent,
    MediaComponent,
    MediaEnquiriesComponent,
    MediaReleasesComponent,
    VideosComponent,
    NewslettersComponent,
    ContactUsComponent,
    TermsComponent,
    DisclaimerComponent,
    PopiComponent,
    CareersComponent,
    AlumniComponent,
    SiteMapComponent,
    InfrastructureDevelopmentAndFacilitiesManagementComponent,
    SouthAfricanMarineFuelsComponent,
    SmallBusinessFinanceSolutionComponent,
    WildCoastSezComponent,
    CoegaAfricaProgrammeComponent,
    DepartmentOfEducationComponent,
    DepartmentOfHealthComponent,
    DepartmentOfSocialDevelopmentComponent,
    DepartmentOfTourismComponent,
    PublicWorksComponent,
    MediaArticleComponent,
    TenderDownloadComponent,
    CurrentVacanciesComponent,
    ApplyComponent,
    SiteSearchComponent,
    ToastComponent,
    BsaComponent,
    BsaEnquiryComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    NgMarqueeModule,
    AppConfig,
    FormsModule,
    //NgxPageScrollCoreModule,
    RouterModule.forRoot([

      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'footer', component: FooterComponent, pathMatch: 'full' },
      { path: 'about-us', component: AboutUsComponent, pathMatch: 'full' },

      { path: 'about-us/careers-and-training', component: CareersAndTrainingComponent, pathMatch: 'full' },
      //{ path: 'about-us/careers/current-vacancies', component: CurrentVacanciesComponent, pathMatch: 'full' },
      { path: 'careers', component: CurrentVacanciesComponent, pathMatch: 'full' },
      { path: 'about-us/careers/current-vacancies/apply', component: ApplyComponent, pathMatch: 'full' },
      { path: 'about-us/coega-development-foundation', component: CoegaDevelopmentFoundationComponent, pathMatch: 'full' },
      { path: 'about-us/important-links', component: ImportantLinksComponent, pathMatch: 'full' },
      { path: 'about-us/locations', component: LocationsComponent, pathMatch: 'full' },
      { path: 'about-us/shareholder-information', component: ShareholderInformationComponent, pathMatch: 'full' },
      { path: 'about-us/smme', component: SmmeComponent, pathMatch: 'full' },
      //{ path: 'about-us/who-we-are', component: WhoWeAreComponent, pathMatch: 'full' },
      { path: 'about-us/our-people', component: WhoWeAreComponent, pathMatch: 'full' },
      { path: 'about-us/coega-development-corporation', component: CoegaDevelopmentCorporationComponent, pathMatch: 'full' },


      { path: 'sez-investments', component: SezInvestmentsComponent, pathMatch: 'full' },
      { path: 'sez-investments/incentives', component: IncentivesComponent, pathMatch: 'full' },
      { path: 'sez-investments/investment-sectors', component: InvestmentSectorsComponent, pathMatch: 'full' },
      { path: 'sez-investments/10-reasons-to-invest', component: ReasonsToInvestComponent, pathMatch: 'full' },
      { path: 'sez-investments/sez-operations', component: SezOperationsComponent, pathMatch: 'full' },
      { path: 'sez-investments/nmblp', component: NmblpComponent, pathMatch: 'full' },
      { path: 'sez-investments/our-investors', component: OurInvestorsComponent, pathMatch: 'full' },
      { path: 'sez-investments/one-stop-investors-service-centre', component: OneStopInvestorsServiceCentreComponent, pathMatch: 'full' },

      { path: 'commercial-services', component: CommercialServicesComponent, pathMatch: 'full' },
      { path: 'commercial-services/coega-human-capital-solutions', component: CoegaHumanCapitalSolutionsComponent, pathMatch: 'full' },
      { path: 'commercial-services/coega-vulindela-accommodation-and-conference-centre', component: CoegaVulindelaAccommodationAndConferenceCentreComponent, pathMatch: 'full' },
      { path: 'commercial-services/coega-corporate-travel', component: CoegaCorporateTravelComponent, pathMatch: 'full' },
      { path: 'commercial-services/bluewater-bay-sunrise-hotel', component: BluewaterBaySunriseHotelComponent, pathMatch: 'full' },
      { path: 'commercial-services/event-management-services', component: EventManagementServicesComponent, pathMatch: 'full' },
      { path: 'commercial-services/coega-telecoms', component: CoegaTelecomsComponent, pathMatch: 'full' },
      { path: 'commercial-services/crux-maritime-solutions', component: CruxMaritimeSolutionsComponent, pathMatch: 'full' },


      { path: 'project-management-services', component: ProjectManagementServicesComponent, pathMatch: 'full' },
      { path: 'project-management-services/projects-map', component: ProjectsMapComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes', component: OurProgrammesComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-clients', component: OurClientsComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management', component: InfrastructureDevelopmentAndFacilitiesManagementComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management/department-of-education', component: DepartmentOfEducationComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management/department-of-health', component: DepartmentOfHealthComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management/department-of-social-development', component: DepartmentOfSocialDevelopmentComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management/department-of-tourism', component: DepartmentOfTourismComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/infrastructure-development-and-facilities-management/public-works', component: PublicWorksComponent, pathMatch: 'full' },

      { path: 'project-management-services/our-programmes/south-african-marine-fuels', component: SouthAfricanMarineFuelsComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/small-business-finance-solution', component: SmallBusinessFinanceSolutionComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/wild-coast-sez', component: WildCoastSezComponent, pathMatch: 'full' },
      { path: 'project-management-services/our-programmes/coega-africa-programme', component: CoegaAfricaProgrammeComponent, pathMatch: 'full' },



      { path: 'tenders', component: TendersComponent, pathMatch: 'full' },
      { path: 'tenders/current-tenders', component: CurrentTendersComponent, pathMatch: 'full' },
      { path: 'tenders/tender-results', component: TenderResultsComponent, pathMatch: 'full' },
      { path: 'tenders/awarded-tenders', component: AwardedTendersComponent, pathMatch: 'full' },
      { path: 'tenders/archived-tenders', component: ArchivedTendersComponent, pathMatch: 'full' },
      { path: 'tenders/tender-download', component: TenderDownloadComponent, pathMatch: 'full' },
      { path: 'tenders/process-payment', component: ProcessPaymentComponent, pathMatch: 'full' },

      { path: 'gallery', component: GalleryComponent, pathMatch: 'full' },
      { path: 'gallerylanding', component: GalleryLandingComponent, pathMatch: 'full' },

      { path: 'document-library', component: DocumentLibraryComponent, pathMatch: 'full' },

      { path: 'media', component: MediaComponent, pathMatch: 'full' },
      { path: 'media/media-enquiries', component: MediaEnquiriesComponent, pathMatch: 'full' },
      { path: 'media/media-releases', component: MediaReleasesComponent, pathMatch: 'full' },
      { path: 'media/newsletters', component: NewslettersComponent, pathMatch: 'full' },
      { path: 'media/media-releases/media-article', component: MediaArticleComponent, pathMatch: 'full' },
      { path: 'media/videos', component: VideosComponent, pathMatch: 'full' },

      { path: 'contact-us', component: ContactUsComponent, pathMatch: 'full' },

      { path: 'terms', component: TermsComponent, pathMatch: 'full' },

      { path: 'disclaimer', component: DisclaimerComponent, pathMatch: 'full' },

      { path: 'popi', component: PopiComponent, pathMatch: 'full' },

      { path: 'careers', component: CareersComponent, pathMatch: 'full' },

      { path: 'alumni', component: AlumniComponent, pathMatch: 'full' },

      { path: 'site-map', component: SiteMapComponent, pathMatch: 'full' },

      { path: 'site-search', component: SiteSearchComponent, pathMatch: 'full' },
      { path: 'bsa', component: BsaComponent, pathMatch: 'full' },
      { path: 'bsa/bsa-enquiry', component: BsaEnquiryComponent, pathMatch: 'full' },
      { path: '**', component: PageNotFoundComponent, pathMatch: 'full' }

    ], routerOptions),
    RecaptchaModule,  //this is the recaptcha main module
    RecaptchaFormsModule //this is the module for form incase form validation
  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
